// Annotations loading
export const ANNOTATIONS_REQUEST = 'ANNOTATIONS_REQUEST';
export const ANNOTATIONS_SUCCESS = 'ANNOTATIONS_SUCCESS';
export const ANNOTATIONS_FAILURE = 'ANNOTATIONS_FAILURE';

// Metadata management removed with deprecation

// UI state management
export const CLEAR_ANNOTATIONS = 'CLEAR_ANNOTATIONS';
export const SET_ANNOTATIONS_FILTER = 'SET_ANNOTATIONS_FILTER';
export const TOGGLE_ANNOTATION_TYPE = 'TOGGLE_ANNOTATION_TYPE';
export const SET_ANNOTATIONS_VISIBLE = 'SET_ANNOTATIONS_VISIBLE';
export const SET_ANNOTATION_CREATE_MODE = 'SET_ANNOTATION_CREATE_MODE';
// Which chart (entity key) is currently focused for note creation. Scopes the
// page-level create-mode to a single chart so 'Add note' doesn't arm every
// trend chart on a multi-tag page at once.
export const SET_ACTIVE_ANNOTATION_ENTITY = 'SET_ACTIVE_ANNOTATION_ENTITY';

const annotationTypes = {
  // Annotations loading
  ANNOTATIONS_REQUEST,
  ANNOTATIONS_SUCCESS,
  ANNOTATIONS_FAILURE,

  // Metadata actions removed

  // UI state management
  CLEAR_ANNOTATIONS,
  SET_ANNOTATIONS_FILTER,
  TOGGLE_ANNOTATION_TYPE,
  SET_ANNOTATIONS_VISIBLE,
  SET_ANNOTATION_CREATE_MODE,
  SET_ACTIVE_ANNOTATION_ENTITY
};

export default annotationTypes;
